/*
 * Copyright (c) 2022
 * 
 * Created Date: Tuesday, October 4th 2022, 10:30:10 am
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

import { APP_ROUTE_PREFIX } from "routes/RoutePrefix";
import { NavigateOptions, To, useLocation, useNavigate } from "react-router-dom"

/**
 * 
 * @returns {UseLunaNavigateHooks}
 */
const useLunaNavigate = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const getParentRoutePrefix = () => {
        return APP_ROUTE_PREFIX;
    }

    const lunaNavigate = (to, options = {}) => {
        navigate(`${getParentRoutePrefix()}/${to}`, options)
    }

    const redirectQueryParamBuilder = (withRedirect, redirectUrl = null) => {
        if (!withRedirect) return `/`
        if (!redirectUrl) return `/?redirectUrl=${encodeURIComponent(location?.pathname)}`
        return `/?redirectUrl=${encodeURIComponent(redirectUrl)}`
    }

    const redirectToAuth = (withRedirect = false, redirectUrl = null) => {
        navigate(redirectQueryParamBuilder(withRedirect, redirectUrl), {
            replace: true
        })
    }

    return {
        lunaNavigate,
        redirectToAuth
    }
}

export default useLunaNavigate